function showPopup(target) {
  document.querySelector(`.popup[data-popup="${target}"]`).classList.add("active")
}

document.querySelectorAll("[data-popup]").forEach(button => {
  button.addEventListener("click", () => showPopup(button.getAttribute("data-popup")))
})
document.querySelectorAll("[data-close-popup]").forEach(button => {
  button.addEventListener("click", event => {
    document.querySelectorAll(".__popup__overlay.active").forEach(popup => popup.classList.remove("active"))
    event.stopImmediatePropagation()
  })
})